<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card class="pa-1">
        <v-card-title>
          <span class="titulo-modal"
            >{{ isEditarGrupo ? "Editar" : "Adicionar" }} grupo</span
          >
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form v-model="valid" ref="formGrupo">
              <v-row>
                <v-col cols="12" sm="12" md="12" class="pa-0">
                  <v-text-field
                    class="font-size"
                    :counter="50"
                    label="Descricao"
                    v-model="descricao"
                    :rules="rules"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="5" sm="5" md="5" class="p-0">
                  <v-text-field
                    v-model="pesquisarParaAdicionar"
                    append-icon="mdi-magnify"
                    append-outer-icon="mdi-order-alphabetical-ascending"
                    @keyup="filtrarParaAdicionar"
                    @click:append-outer="filtrarParaAdicionar"
                    label="Pesquisar funcionário para adicionar"
                    single-line
                    hide-details
                    class="pa-0"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon @click="filtrarParaAdicionar" v-on="on">
                            mdi-order-alphabetical-ascending
                          </v-icon>
                        </template>
                        Ordem alfabética
                      </v-tooltip>
                    </template>
                  </v-text-field>
                  <br />
                  <div class="coluna-esquerda">
                    <draggable
                      tag="ul"
                      group="all-users"
                      class="draggable-list"
                      ghost-class="moving-card"
                      filter=".action-button"
                      :list="funcionariosParaAdicionarFiltrados"
                      :animation="200"
                      @change="handleChangeListaParaAdicionar"
                    >
                      <CardFuncionario
                        v-for="funcionario in funcionariosParaAdicionarFiltrados"
                        :funcionario="funcionario"
                        :key="funcionario.id"
                      >
                      </CardFuncionario>
                    </draggable>
                  </div>
                  <div class="dica">* Clique no funcionário para marcar</div>
                  <div class="d-flex">
                    <v-btn
                      :disabled="funcionariosParaAdicionarFiltrados.length == 0"
                      class="btn-drag ml-0"
                      @click="adicionarTodosFuncionarios"
                    >
                      Adicionar todos
                    </v-btn>
                    <v-btn
                      :disabled="funcionariosParaAdicionarFiltrados.length == 0"
                      class="btn-limpar"
                      @click="removerMarcacao(funcionariosParaAdicionarFiltrados)"
                    >
                      Desemarcar
                    </v-btn>                   
                  </div>
                </v-col>
                <v-col cols="2" sm="2" md="2" class="pa-0 mt-12">
                  <div class="coluna-meio d-flex justify-center">
                    <v-btn  @click="transferirEntreColunas"
                            outlined
                            color="primary"
                            class="d-flex align-self-center btn-transferir">
                        <v-icon>mdi-swap-horizontal</v-icon>
                        Transferir<br>marcados
                    </v-btn>
                  </div>
                </v-col>

                <v-col cols="5" class="p-0">
                  <v-text-field
                    v-model="pesquisarAdicionados"
                    append-icon="mdi-magnify"
                    append-outer-icon="mdi-order-alphabetical-ascending"
                    label="Pesquisar funcionário já adicionado"
                    single-line
                    hide-details
                    class="pa-0"
                    @keyup="filtrarAdicionados"
                    @click:append-outer="filtrarAdicionados"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon @click="filtrarAdicionados" v-on="on">
                            mdi-order-alphabetical-ascending
                          </v-icon>
                        </template>
                        Ordem alfabética
                      </v-tooltip>
                    </template>
                  </v-text-field>
                  <br />

                  <div class="coluna-direita">
                    <draggable
                      tag="ul"
                      group="all-users"
                      class="draggable-list"
                      ghost-class="moving-card"
                      filter=".action-button"
                      :list="funcionariosAdicionadosFiltrados"
                      :animation="200"
                      @change="handleChangeListaAdicionados"
                    >
                      <CardFuncionario
                        v-for="funcionario in funcionariosAdicionadosFiltrados"
                        :funcionario="funcionario"
                        :key="funcionario.id"
                      >
                      </CardFuncionario>
                    </draggable>
                  </div>
                  <div class="dica">* Clique no funcionário para marcar</div>
                  <div class="d-flex">
                      <v-btn
                        :disabled="this.funcionariosAdicionadosFiltrados.length == 0"
                        class="btn-drag ml-0"
                        @click="removerTodosFuncionarios"
                      >
                        Remover todos
                      </v-btn>
                      <v-btn
                          :disabled="this.funcionariosAdicionadosFiltrados.length == 0"
                          class="btn-limpar"
                          @click="removerMarcacao(funcionariosAdicionadosFiltrados)"
                        >
                          Desmarcar
                      </v-btn>
                  </div>

                </v-col>

              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            class="btn-primary ml-0 mb-3"
            @click="handleSalvar"
            text
          >
            <v-progress-circular
              indeterminate
              v-if="carregando"
              color="white"
              :size="25"
              :width="3"
            >
            </v-progress-circular>
            <div v-else>Salvar</div>
          </v-btn>
          <v-btn
            class="btn-quaternary ml-0 mb-3"
            text
            @click="$emit('fecharModal')"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Grupo from "@/model/grupo/Grupo";
import grupoService from "@/api/grupo/grupo-api";
import Draggable from "vuedraggable";
import CardFuncionario from "../comum/CardFuncionario.vue";
import storage from "@/utils/storage";
import { reject } from "q";

export default {
  components: { CardFuncionario, Draggable },
  props: {
    funcionarios: { type: Array, require: true },
    grupoSelecionado: { type: Object, require: true },
  },
  data: () => ({
    descricao: "",
    pesquisarParaAdicionar: "",
    pesquisarAdicionados: "",
    dialog: true,
    isEditarGrupo: false,
    carregando: false,
    valid: false,
    rules: [
        value => !!value || 'Descrição é obrigatória.',
        value => (value && value.length < 50) || 'Max. 50 Caracteres',
    ],
    listaTemporariaFuncionarios: [],
    funcionariosParaAdicionarFiltrados: [],
    funcionariosAdicionadosFiltrados: [],
    grupoTemporario: new Grupo(),
    novoGrupo: new Grupo(),
   
  }),
  methods: {
    handleChangeListaParaAdicionar(e) {
      this.removerMarcacao(this.listaTemporariaFuncionarios);
      if (e && e.removed && e.removed.element) {
        const indiceARemover = this.listaTemporariaFuncionarios.indexOf(
          e.removed.element
        );
        if (indiceARemover > -1) {
          this.listaTemporariaFuncionarios.splice(indiceARemover, 1);
        }
      }
      if (e && e.added && e.added.element) {
        if (this.funcionariosParaAdicionarFiltrados.includes(e.added.element)) {
          const indiceARemover = this.listaTemporariaFuncionarios.indexOf(
            e.added.element
          );
          if (indiceARemover > -1) {
            this.listaTemporariaFuncionarios.splice(indiceARemover, 1);
          }
        }
        this.listaTemporariaFuncionarios.push(e.added.element);
      }
      this.pesquisarParaAdicionar = "";
      this.filtrarParaAdicionar();      
    },

    handleChangeListaAdicionados(e) {
      this.removerMarcacao(this.grupoTemporario.funcionariosGrupo);
      if (e && e.removed && e.removed.element) {
        const indiceARemover = this.grupoTemporario.funcionariosGrupo.indexOf(
          e.removed.element
        );
        if (indiceARemover > -1) {
          this.grupoTemporario.funcionariosGrupo.splice(indiceARemover, 1);
        }
      }
      if (e && e.added && e.added.element) {
        if (this.funcionariosAdicionadosFiltrados.includes(e.added.element)) {
          const indiceARemover = this.grupoTemporario.funcionariosGrupo.indexOf(
            e.added.element
          );
          if (indiceARemover > -1) {
            this.grupoTemporario.funcionariosGrupo.splice(indiceARemover, 1);
          }
        }
        this.grupoTemporario.funcionariosGrupo.push(e.added.element);
      }
      this.pesquisarAdicionados = "";
      this.filtrarAdicionados();
    },

    filtrarParaAdicionar() {
      if (this.pesquisarParaAdicionar) {
        this.funcionariosParaAdicionarFiltrados =
          this.listaTemporariaFuncionarios
            .filter((funcionario) => funcionario.login.includes(this.pesquisarParaAdicionar))
            .sort((funcionarioAtual, funcionarioSubsequente) => funcionarioAtual.login.localeCompare(funcionarioSubsequente.login))
            .map((funcionarioFiltrado) => {
              funcionarioFiltrado.selecionado = true
              return funcionarioFiltrado;
            });
      } else {
        this.funcionariosParaAdicionarFiltrados =
          this.listaTemporariaFuncionarios
            .sort((funcionarioAtual, funcionarioSubsequente) => funcionarioAtual.login.localeCompare(funcionarioSubsequente.login))
            .map((funcionarioFiltrado) => {
              funcionarioFiltrado.selecionado = false;
              return funcionarioFiltrado;
            });
      }
    },

    filtrarAdicionados() {
      if (this.pesquisarAdicionados) {
        this.funcionariosAdicionadosFiltrados =
          this.grupoTemporario.funcionariosGrupo
            .filter((funcionario) => funcionario.login.includes(this.pesquisarAdicionados))
            .sort((funcionarioAtual, funcionarioSubsequente) => funcionarioAtual.login.localeCompare(funcionarioSubsequente.login))
            .map((funcionarioGrupo) => { 
              funcionarioGrupo.selecionado = true;
              return funcionarioGrupo;
            });
      } else {
        this.funcionariosAdicionadosFiltrados =
          this.grupoTemporario.funcionariosGrupo
          .sort((funcionarioAtual, funcionarioSubsequente) => funcionarioAtual.login.localeCompare(funcionarioSubsequente.login))
          .map((funcionarioGrupo) => {
            funcionarioGrupo.selecionado = false;
            return funcionarioGrupo;
          });
      }
    },

    adicionarTodosFuncionarios() {
      this.funcionariosParaAdicionarFiltrados.forEach((funcionario) => {
          this.adicionarFuncionarioEmLista(funcionario, this.grupoTemporario.funcionariosGrupo);
      });
      this.listaTemporariaFuncionarios = this.listaTemporariaFuncionarios.filter(
          (funcionario) => !this.funcionariosParaAdicionarFiltrados.includes(funcionario)
      );
      this.pesquisarAdicionados = "";
      this.pesquisarParaAdicionar = "";
      this.filtrarAdicionados();
      this.filtrarParaAdicionar();
    },

    adicionarFuncionarioEmLista(funcionario, lista) {
        const copiaFuncionario = {...funcionario};
        copiaFuncionario.selecionado = false;
        if(!this.grupoTemporario.funcionarioGrupo)
        {
          lista.push(copiaFuncionario);
        }
        else if(!this.grupoTemporario.funcionarioGrupo.includes(copiaFuncionario)) {
          this.grupoTemporario.funcionarioGrupo.push(copiaFuncionario);
        }        
    },

    removerTodosFuncionarios() {
      this.funcionariosAdicionadosFiltrados.forEach((funcionario) => {
        this.adicionarFuncionarioEmLista(funcionario, this.listaTemporariaFuncionarios);
      });
      this.grupoTemporario.funcionariosGrupo = this.grupoTemporario.funcionariosGrupo.filter (
          (funcionario) => !this.funcionariosAdicionadosFiltrados.includes(funcionario)
      );
      this.pesquisarAdicionados = "";
      this.pesquisarParaAdicionar = "";
      this.filtrarAdicionados();
      this.filtrarParaAdicionar();
    },

    transferirEntreColunas() {
      this.funcionariosParaAdicionarFiltrados.filter(funcionario => funcionario.selecionado).forEach((funcionarioSelecionado) => {
        this.adicionarFuncionarioEmLista(funcionarioSelecionado, this.grupoTemporario.funcionariosGrupo);
      });
      this.listaTemporariaFuncionarios = this.listaTemporariaFuncionarios.filter((funcionario) => !funcionario.selecionado);      
      this.funcionariosAdicionadosFiltrados.filter(funcionario => funcionario.selecionado).forEach((funcionarioSelecionado) => {
          this.adicionarFuncionarioEmLista(funcionarioSelecionado, this.listaTemporariaFuncionarios);
      });
      this.grupoTemporario.funcionariosGrupo = this.grupoTemporario.funcionariosGrupo.filter ((funcionario) => !funcionario.selecionado);
      this.pesquisarParaAdicionar = "";
      this.filtrarParaAdicionar();
      this.pesquisarAdicionados = "";
      this.filtrarAdicionados();
    },

    async editarGrupo() {
      this.definirNovoGrupo();
      await grupoService
        .atualizar(this.grupoSelecionado.id, new Grupo(this.novoGrupo))
        .then((response) => {
          this.$emit("editarGrupo", response.data);
        })
        .catch((error) => reject(error));
    },

    async adicionarGrupo() {
      this.definirNovoGrupo();

      await grupoService
        .cadastrar(new Grupo(this.novoGrupo))
        .then((response) => {
          this.$emit("adicionarGrupo", response.data);
        })
        .catch((error) => reject(error));
    },

    definirNovoGrupo() {
      this.pesquisarAdicionados = "";
      this.novoGrupo.descricao = this.descricao;
      this.novoGrupo.loginUsuarioCriador =
        storage.obterUsuarioAtualStorage().login;
      this.novoGrupo.loginsFuncionarios =
        this.grupoTemporario.funcionariosGrupo.map(
          (funcionario) => funcionario.login
        );
    },

    async handleSalvar() {
      if(!this.valid || !this.grupoTemporario.funcionariosGrupo || this.grupoTemporario.funcionariosGrupo.length == 0){
        this.$refs.formGrupo.validate();
        return;
      }
      this.carregando = true;
      if (this.isEditarGrupo) {
        try {
          await this.editarGrupo();
        } catch (error) {
          this.$emit(
            "erroEditarGrupo",
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
              "Não foi possível se comunicar com o servidor!"
          );
        }
      } else {
        try {
          await this.adicionarGrupo();
        } catch (error) {
          this.$emit(
            "erroAdicionarGrupo",
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
              "Não foi possível se comunicar com o servidor!"
          );
        }
      }
      this.carregando = false;
    },

    obterInformacoes() {
      this.listaTemporariaFuncionarios = this.funcionarios
          .sort((funcionarioAtual, funcionarioSubsequente) => funcionarioAtual.login.localeCompare(funcionarioSubsequente.login));
      if (!this.grupoSelecionado.id) {
        //Adicionar
        this.isEditarGrupo = false;
        this.grupoTemporario = new Grupo();
        this.grupoTemporario.funcionariosGrupo = [];
        this.funcionariosParaAdicionarFiltrados = this.funcionarios;
      } else {
        //Editar
        this.isEditarGrupo = true;
        this.descricao = this.grupoSelecionado.descricao;
        this.grupoTemporario = JSON.parse(
          JSON.stringify(this.grupoSelecionado)
        );
        this.grupoTemporario.funcionariosGrupo =
          this.grupoSelecionado.funcionariosGrupo
              .sort((funcionarioAtual, funcionarioSubsequente) => funcionarioAtual.login.localeCompare(funcionarioSubsequente.login));
        this.funcionariosAdicionadosFiltrados =
          this.grupoSelecionado.funcionariosGrupo
              .sort((funcionarioAtual, funcionarioSubsequente) => funcionarioAtual.login.localeCompare(funcionarioSubsequente.login));
        this.funcionariosParaAdicionarFiltrados =
          this.listaTemporariaFuncionarios.filter(
            (x) =>
              !this.funcionariosAdicionadosFiltrados.some(
                (y) => y.login === x.login
              )
          );
      }
    },

    removerMarcacao(listaFuncionarios) {
      if(!listaFuncionarios) return;
      listaFuncionarios.forEach((funcionario) => funcionario.selecionado = false);
    }

  },
  mounted() {
    this.obterInformacoes();
  },
};
</script>

<style lang="scss" scoped>
.font-size {
  font-size: 16px;
}

.v-input .v-label {
  font-size: 1.2em;
}

.draggable-list {
  padding: 0;
  min-height: 250px;
}

.moving-card {
  opacity: 0.5;
  background: #f7fafc;
}

.coluna-esquerda,
.coluna-direita,
.coluna-meio {
  border-radius: 3px;
  height: 225px;
  margin: 0;
  padding: 0;
  text-align: center;
}

@media screen and (min-height: 800px) {
  .coluna-esquerda,
  .coluna-direita,
  .coluna-meio {
    height: 440px;
  }
}

.coluna-esquerda::-webkit-scrollbar {
  width: 7px;
}

.coluna-esquerda::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgb(206, 205, 205);
}

.coluna-esquerda::-webkit-scrollbar-track {
  padding: 2px 0;
}

.coluna-esquerda {
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.2);
  overflow-y: scroll;
  overflow-x: hidden;
}

.coluna-direita::-webkit-scrollbar {
  width: 7px;
}

.coluna-direita::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgb(208, 221, 254);
}

.coluna-direita::-webkit-scrollbar-track {
  padding: 2px 0;
}

.coluna-direita {
  padding: 10px;
  background-color: rgba(63, 81, 181, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.2);
  overflow-y: scroll;
  overflow-x: hidden;
}

i.tamanho-icone {
  font-size: 70px;
}

.btn-drag {
  border-radius: 2px;
  border: 1px solid $cor_primaria;
  width: 60% !important;
  color: $cor_primaria !important;
  background-color: white !important;
}
.btn-limpar {
  border-radius: 2px;
  border: 1px solid $cor_primaria;
  width: 35% !important;
  color: $cor_primaria !important;
  background-color: white !important;
}
.btn-transferir {
  background-color: white !important;
}
.dica {
  font-style: italic;
  font-size: smaller;
  margin-bottom: 0.3rem;
  text-align: center;
}
</style>
